import React from "react";
import { CameraOffIcon, ImageOffIcon, SlidersHorizontalIcon, VideoOffIcon } from "lucide-react";
import { problems } from "../data/content";
import { SectionHeading } from "./SectionHeading";
const icons = [ImageOffIcon, SlidersHorizontalIcon, CameraOffIcon, VideoOffIcon];
export function ProblemsSection() {
  return <section className="bg-mint py-16 md:py-24" data-id="element-218" data-mp="36ncq9mliv67i">
      <div className="wrap" data-id="element-219" data-mp="2sowbr9hf4bet">
        <SectionHeading eyebrow="¿Te pasa esto?" title={<>
              Tu producto está buenísimo. <span className="text-gold-dark" data-id="element-221" data-mp="2xpkc4lrje4lp">La foto no lo demuestra.</span>
            </>} intro="Trabajás en cada detalle de tu negocio. Pero cuando llega el momento de mostrarlo, abrís la cámara y no sabés bien qué hacer." data-id="element-220" data-mp="2somse4qvp2i3" />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-222" data-mp="gzlmi80poqvf">
          {problems.map((problem, index) => {
          const Icon = icons[index % icons.length];
          return <article key={problem.title} className="flex flex-col rounded-2xl border border-line bg-white p-6 shadow-[0_10px_30px_rgba(20,39,85,0.06)]" data-id="element-223" data-mp="1i66iulydy4ly" data-mpi={index}>
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-forest text-gold" data-id="element-224" data-mp="1rwri8blvvd5x">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-225" data-mp="1mwwpe2ijsdi8" />
                </span>
                <h3 className="display-title mt-5 text-[26px] leading-none text-ink" data-id="element-226" data-mp="z72ehqhsgz0m">{problem.title}</h3>
                <p className="mt-3 text-[15px] text-muted" data-id="element-227" data-mp="u90un3cjgvo3">{problem.body}</p>
              </article>;
        })}
        </div>
        <p className="mx-auto mt-12 max-w-[760px] text-center text-xl font-bold leading-snug text-ink md:text-2xl" data-id="element-228" data-mp="189tt1z5yoawh">
          Ya invertiste en el teléfono. <span className="text-gold-dark" data-id="element-229" data-mp="2jn5r1tf1hzaq">Ahora aprendé a aprovechar su cámara.</span>
        </p>
      </div>
    </section>;
}